import actionCreators from "./actionCreators";

const initialState = {
    members: {
        data: [],
        count: 0,
        nextPage: 0,
    },
    errorRes: { error: "", errors: {} },
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case actionCreators.createListMembers.type:
            return {
                ...state,
                members: payload ? payload : state.members,
                errorRes: initialState.errorRes,
            };
        case actionCreators.updateListMembers.type:
            payload.data = [
                ...state.members.data,
                ...payload.data.filter(
                    member => !state.members.data.map(item => item.id).includes(member.id)
                ),
            ];
            return {
                ...state,
                members: payload ? payload : state.members,
                errorRes: initialState.errorRes,
            };
        case actionCreators.clearListMembers.type:
            return {
                ...state,
                members: initialState.members,
            };
        case actionCreators.errorResponse.type:
            return {
                ...state,
                errorRes: payload,
            };
        case actionCreators.reset.type:
            return initialState;
        default:
            return state;
    }
};
